(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('UserSearchService', ['$http', 'SharedAgendaService', 'RoleType', 'HelperService', UserSearchServiceFn]);

    /* main user search service */
    function UserSearchServiceFn($http, SharedAgendaService, RoleType, HelperService) {
        var baseUrl = '/api/users/';

        var service = {
            quicksearch: quicksearch,
            groupPracticeSearch: groupPracticeSearch,
            searchByBirthday: searchByBirthday,
            searchByEmail: searchByEmail,
            searchByRoleTypes: searchByRoleTypes,
            search: search,
        };

        return service;

        /* full-text-search with restricted roles */
        function searchByRoleTypes(searchValue, roleTypes, restrict) {
            return $http({
                url: baseUrl + SharedAgendaService.currentUser().id + '/search/roles/agendas/' + SharedAgendaService.data.currentAgenda.id,
                method: 'GET',
                params: {
                    searchValue: searchValue,
                    roleTypes: roleTypes,
                    restrict: restrict
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* main search for ringfoon */
        function search(searchValue) {
            return $http({
                url: baseUrl + SharedAgendaService.getLoggedInUserData().id + '/search/quick/' + true + '/agendas/' + SharedAgendaService.data.currentAgenda.id,
                method: 'GET',
                params: {
                    searchValue: searchValue,
                    roleTypes: [RoleType.MainUser.value, RoleType.SubuserAdmin.value],
                    noLimit: false
                }
            }).then(function (response) {
                return response.data;
            });
        } // search

        /* quick search for users */
        function quicksearch(searchValue, showContactInfoInCaption) {
            return $http({
                url: baseUrl + SharedAgendaService.currentUser().id + '/search/quick/' + showContactInfoInCaption + '/agendas/' + SharedAgendaService.data.currentAgenda.id,
                method: 'GET',
                params: {
                    searchValue: searchValue
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* quick search for users from same grouppractice */
        function groupPracticeSearch(searchValue) {
            let currentUser = SharedAgendaService.currentUser();
            return $http({
                url: baseUrl + currentUser.id + '/agendas/' + SharedAgendaService.data.currentAgenda.id + '/search/grouppractice/'+ currentUser.groupPracticeId,
                params: {
                    searchValue: searchValue
                },
                method: 'GET'
            }).then(function (response) {
                return HelperService.prepareUserSearchResult(response.data.results, true);
            });
        }

        /* search users by birthday */
        function searchByBirthday(birthday) {

            return $http({
                url: baseUrl + SharedAgendaService.currentUser().id + '/search/birthday/agendas/' + SharedAgendaService.data.currentAgenda.id,
                params: {
                    birthday: birthday
                },
                method: 'GET'
            }).then(function (response) {
                return response.data;
            });
        }

        /* search users by email */
        function searchByEmail(email) {
            return $http({
                url: baseUrl + SharedAgendaService.currentUser().id + '/search/email/agendas/' + SharedAgendaService.data.currentAgenda.id,
                params: {
                    searchValue: email
                },
                method: 'GET'
            }).then(function (response) {
                return response.data;
            });
        }
    }
})();